import ChangePasswordForm from '@/components/ChangePasswordForm';

export default function SuperAdminProfile() {
  return (
    <div>
      <div className="admin-page-header">
        <div>
          <h1 className="admin-page-title">پروفایل</h1>
          <p className="admin-page-subtitle">مدیریت امنیت حساب سوپر ادمین</p>
        </div>
      </div>
      <ChangePasswordForm />
    </div>
  );
}
